import fetchServer from "../fetchServer";

/**
 * Reject Business Change Request [Admin]
 * PATCH /main/v1/account/:id/business-change-requests/:requestId/reject
 * Body: { reason }
 */
export default async function rejectBusinessVerification(
  accountId,
  requestId,
  reason,
) {
  let result = {
    return: 0,
    msg: "Something went wrong rejecting verification!",
  };

  if (!accountId || !requestId) {
    result.msg = "Missing account or business change request id.";
    return result;
  }

  await fetchServer({
    method: "PATCH",
    url: `/main/v1/account/${encodeURIComponent(
      accountId,
    )}/business-change-requests/${encodeURIComponent(requestId)}/reject`,
    data: { reason: String(reason || "").trim() },
  })
    .then((res) => {
      if (
        res?.data &&
        !res?.data?.error &&
        res?.status >= 200 &&
        res?.status < 300
      ) {
        result = {
          return: 1,
          msg: res.data?.message || "Rejected",
          data: res.data?.data || res.data,
        };
      } else {
        result.msg = res?.data?.error || res?.data?.message || result.msg;
      }
    })
    .catch(() => {
      console.log("Network Error!");
    });

  return result;
}
